import { ReactNode } from 'react';
import { Close, SvgIconComponent } from '@mui/icons-material';
import { Box, IconButton, Stack, StackProps, Typography } from '@mui/material';
import { Link, To } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';

type Props = StackProps & {
  title: string;
  titleSlot?: ReactNode;
  subtitle?: string | null;
  backRouteTo?: To | null | -1;
  action?: ReactNode;
  Icon?: SvgIconComponent;
};

export const PageHeader = ({
  title,
  subtitle,
  Icon = Close,
  titleSlot = null,
  backRouteTo = '/',
  action,
  ...stackProps
}: Props) => {
  usePageTitle(title);
  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      flexWrap={'wrap'}
      gap={{
        xs: 2,
        sm: 4,
      }}
      {...stackProps}
    >
      {backRouteTo ? (
        <Box display={'flex'} alignItems={'flex-start'} mt={1}>
          <IconButton component={Link} to={backRouteTo as To} color={'primary'} size={'large'} sx={{ border: 1 }}>
            {<Icon />}
          </IconButton>
        </Box>
      ) : null}
      <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
        <Box display={'flex'} alignItems={'center'} gap={1}>
          <Typography variant={'h1'}>{title}</Typography>
          {titleSlot}
        </Box>
        {subtitle ? <Typography variant={'subtitle1'}>{subtitle}</Typography> : null}
      </Box>
      {action ? (
        <Box display={'flex'} flex={1} justifyContent={'flex-end'}>
          {action}
        </Box>
      ) : null}
    </Stack>
  );
};
